// src/confluence/long-running-task/types.ts
var ConfluenceLongRunningTaskAriResourceOwner = "confluence", ConfluenceLongRunningTaskAriResourceType = "long-running-task";

export {
  ConfluenceLongRunningTaskAriResourceOwner,
  ConfluenceLongRunningTaskAriResourceType
};
